export default "__VITE_ASSET__fbDw7zpi__"